module.exports = __webpack_public_path__ + "img/shipo-map-proximity.dcbef8fe.svg";